<template>
  <div :class="[colClassName]">
    <div v-if="isValidation" class="inputTextValidation">
      <validation-provider
        :rules="rules"
        v-slot="{ validated, valid, errors }"
        slim
        :name="labelName"
      >
        <b-form-group
          :label="labelName"
          :invalid-feedback="errors[0]"
          :label-sr-only="isLabel ? false : true"
          :label-cols="isLabel ? '4' : false"
          :label-cols-md="isLabel ? '2' : false"
        >
          <b-input
            v-if="isText"
            v-model="inputVal"
            :state="validated ? valid : null"
            :placeholder="labelName"
            autocomplete="off"
            @keyup="valChange(inputVal)"
          />

          <b-textarea
            v-if="!isText"
            id="form-memo"
            ref="formMemo"
            v-model="inputVal"
            rows="3"
            max-rows="6"
            class="bg-white"
            :state="validated ? valid : null"
            @keyup="valChange(inputVal)"
          />
        </b-form-group>
      </validation-provider>
    </div>
    <div v-if="!isValidation">
      <b-form-group
        :label="labelName"
        :label-cols="isLabel ? '4' : false"
        :label-cols-md="isLabel ? 'auto' : false"
        :label-cols-sm="isLabel ? '3' : false"
        label-class="text-secondary"
        :label-sr-only="isLabel ? false : true"
      >
        <b-input
          v-if="isText"
          v-model="inputVal"
          :placeholder="`請輸入${labelName}`"
          autocomplete="off"
          @keyup="valChange(inputVal)"
        />
        <b-textarea
          v-if="!isText"
          id="form-memo"
          ref="formMemo"
          v-model="inputVal"
          rows="3"
          max-rows="6"
          class="bg-white"
          @keyup="valChange(inputVal)"
        />
      </b-form-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputText',

  props: {
    // 判斷是否為 驗證ipnut
    isValidation: {
      type: Boolean,
      default: false,
    },

    // input值
    val: [String, Number],

    // input 開關
    isText: {
      type: Boolean,
      default: true,
    },

    // 驗證規則
    rules: {
      type: String,
      default: '',
    },

    // label名稱
    labelName: {
      type: String,
      default: '',
    },

    isLabel: {
      type: Boolean,
      default: false,
    },

    // col名稱
    colClassName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      inputVal: this.val,
    };
  },

  methods: {
    valChange(val) {
      console.log('val--', val);
      this.$emit('inputVal', this.inputVal);
    },
    upVal(val) {
      this.inputVal = val;
    },
  },
};
</script>
